/* src/app/features/indexadores/pesquisa/indexadores-pesquisa.component.scss */
/*# sourceMappingURL=indexadores-pesquisa.component.css.map */
